import { Button, TextField } from "@material-ui/core";
import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Fade,
  IconButton,
  InputAdornment,
  Link,
  Typography,
} from "@mui/material";
import axios from "axios";
import { Eye, EyeClosed } from "phosphor-react";
import { useState } from "react";
import { createCookie } from "../../Components/authorization";
import { MovieColabLogo } from "../../Components/Utilities/MovieColabLogo";
import signupAndLoginStyles from "./signupAndLoginStyle";
// import { useHistory } from "react-router-dom";

const LoginPage = () => {
  const classes = signupAndLoginStyles();
  // const router=useHistory()
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [loginError, setLoginError] = useState("");

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: "",
      });
    }

    // Clear login error
    if (loginError) {
      setLoginError("");
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setLoginError("");

    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}login/`, {
        email: formData.email,
        password: formData.password,
      });
      if (res) {
        createCookie("refresh", res.data.refresh);
        createCookie("access", res.data.access);
        window.location.href = "/";
      }
      console.log("Login successful:", res);
      // Handle successful login (redirect, store token, etc.)
    } catch (error) {
      console.error("Login error:", error);
      setLoginError(
        error.response?.data?.message ||
          "Login failed. Please check your credentials and try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box className={classes.loginContainer}>
      {/* Purple Glow */}
      <div className={classes.glow} />

      <Box sx={{ width: "500px", zIndex: 2 }}>
        {/* Logo */}
        <Box className={classes.topLogo}>
          <MovieColabLogo />
          <Typography className={classes.brand}>Movie Colab</Typography>
        </Box>

        {/* Card */}
        <Card className={classes.loginCard}>
          <CardContent className={classes.cardContent}>
            <Box className={classes.headerContainer}>
              <Typography className={classes.welcomeTitle}>
                Welcome Back!
              </Typography>
            </Box>

            {loginError && (
              <Fade in>
                <Alert
                  severity="error"
                  className={classes.errorAlert}
                  onClose={() => setLoginError("")}
                >
                  {loginError}
                </Alert>
              </Fade>
            )}

            <Box
              component="form"
              onSubmit={handleLogin}
              className={classes.loginForm}
              noValidate
            >
              {/* Email */}
              <div>
                <span className={classes.inputLabel}>Email</span>
                <div className={classes.inputWrapper}>
                  <TextField
                    type="text"
                    fullWidth
                    value={formData.email}
                    onChange={handleInputChange("email")}
                    error={!!errors.email}
                    helperText={errors.email}
                    InputProps={{
                      disableUnderline: true,
                      style: { fontFamily: "Poppins", marginTop: "5px" },
                    }}
                    className={classes.input}
                    placeholder="Enter email"
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <span className={classes.inputLabel}>Password</span>
                <div className={classes.inputWrapper}>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    fullWidth
                    value={formData.password}
                    onChange={handleInputChange("password")}
                    error={!!errors.password}
                    helperText={errors.password}
                    InputProps={{
                      disableUnderline: true,
                      style: { fontFamily: "Poppins", marginTop: "5px" },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleTogglePasswordVisibility}
                            tabIndex={-1}
                            sx={{ color: "white" }}
                          >
                            {showPassword ? <EyeClosed /> : <Eye />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    className={classes.input}
                    placeholder="Your password here"
                  />
                </div>
              </div>

              {/* Button */}
              <Button
                type="submit"
                disabled={
                  isLoading ||
                  formData?.email === "" ||
                  formData.password === ""
                }
                fullWidth
                className={classes.primaryButton}
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Log In"
                )}
              </Button>
            </Box>

            {/* Bottom */}
            <Divider className={classes.divider} />

            <Box className={classes.linksContainer}>
              <Link href="/forgot-password" className={classes.smallLink}>
                Forgot Password?
              </Link>
              <Link href="/signup" className={classes.bigLink}>
                Create Account
              </Link>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default LoginPage;
